const preselectVariant = ({
  variantsData,
  optionNames,
  form,
  updateSelectedOption,
  variantIdInput,
}) => {
  const url = new URL(window.location.href);
  let variantId = null;

  if (variantIdInput) {
    variantId = variantIdInput.value;
  }
  else {
    variantId = url.searchParams.get('variant');
  }

  if (!variantId) return;

  const variant = variantsData.find(v => String(v.id) === variantId);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    const input = form.querySelector(`[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
    if (input) {
      input.checked = true;
    } else {
      const select = form.querySelector(`select[name="${CSS.escape(name)}"]`);
      if (select) select.value = value;
    }

    updateSelectedOption(name, value);
  });
};

export default preselectVariant;
